import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import NotificationBadge from 'react-notification-badge';
import './ClaimsCard.css';
import { setSelectedClaim } from '../../../actions/profileActions';
import { navigateTo } from '../../../actions/navigationActions';
import { getClaimProgress, getNextProgressStepName, setLoadingAndEmpty } from '../../../actions/claimHistoryActionsV2';
import { isMobile } from "react-device-detect";

class ClaimsCard extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(id) {
        await this.props.dispatchHandleSetLoadingAndEmpty(true, false);
        await this.props.dispatchSetSelectedClaim(id);
        await this.props.dispatchSetClaimProgress(this.props.profile.selectedPersonalClaim.claimID);
        await this.props.dispatchGetNextClaimV2Step();
        await this.props.dispatchHandleSetLoadingAndEmpty(false, false);
    }

    getClaimStatusClass() {
        let cssClass = '';
        switch (this.props.claimStatusCategory) {
            case 'Approved': cssClass = 'Approved'; break;
            case 'Pending': cssClass = 'Pending'; break;
            case 'Cancelled': cssClass = 'Cancelled'; break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    render() {
        let claimStatusClass = this.getClaimStatusClass();

        return (
            <>
                <div className="Claim-card" id={"ClaimCard" + this.props.id}>
                    <Card className={(this.props.id === this.props.profile.selectedPersonalClaim.claimNumber && !isMobile ? 'isClicked content-box-padding-20px-with-box-shadow' : 'content-box-padding-20px-with-box-shadow') + " tile"} onClick={() => this.handleClick(this.props.id)}>
                        <div className="row noma">
                            <div className="col nopa">
                                <div className="">
                                    <p className="mb-10px line-height-normal"><b>{this.props.headerText}</b></p>
                                    <div className="notifcationBadge">
                                        <NotificationBadge count={parseInt(this.props.alertCount)} />
                                    </div>
                                </div>
                                <div className="">
                                    <p className="font-weight-500 mb-10px line-height-normal">{this.props.bodyText}</p>
                                    <p className="font-size-12px mb-0px">Claim no. <b>{this.props.claimNr}</b></p>
                                </div>
                            </div>
                            <div className="">
                                <div className={'dot float-right ' + claimStatusClass}></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimsHistory: state.claimsHistory,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchGetNextClaimV2Step: () => dispatch(getNextProgressStepName()),
        dispatchSetSelectedClaim: (id) => dispatch(setSelectedClaim(id)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetClaimProgress: (id) => dispatch(getClaimProgress(id)),
        dispatchHandleSetLoadingAndEmpty: (loading, empty) => dispatch(setLoadingAndEmpty(loading, empty)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsCard);
